module.exports = {
  App: {},
  Login: {
    username: "用户名：",
    usernamePlaceholder: "请输入用户名",
    password: "密码：",
    passwordPlaceholder: "请输入密码",
    passwordTip: "长度在 6 到 8 个字符",
    role: "角色:",
    rolePlaceholder: "请选择角色",
    login: "登录",
    reset: "重置",

    student: "学生",
    teacher: "教师",
    teacherHeader: "班主任",
    schoolAdmin: "教学管理员",
    systemAdmin: "系统管理员",
  },
  Home: {
    systemName: "学生学业预警管理系统",
    editPassword: "修改密码",
    logout: "退出登录",
    tip: "提示",
    ifLogout: "是否退出登录？",
  },
  MenuNames: {
    home: "主页",

    academicPerformance: "学业成绩",

    academicWarning: "学业预警",
    warningSettings: "预警设置",
    warningQuery: "预警查询",
    academicAssistance: "学业帮扶",

    studentProfile: "学生画像",

    statisticAnalysis: "统计分析",
    studentPerformanceAnalysis: "学生成绩分析",
    academicWarningInformation: "学业预警情况",
    academicWarningAnalysis: "学业预警分析",

    userManagement: "用户管理",
    student: "学生",
    teacherClassAdviser: "教师/班主任",
    teachingManagers: "教学管理员",
    systemAdministrator: "系统管理员",
  },
  TitleInfo: {
    basicInformationOfStudents: "学生基本信息",
  },
  TableInfo: {
    major: "专业",
    majorPlaceholder: "请选择专业",
    grade: "年级",
    grade2: "级",
    gradePlaceholder: "请选择年级",
    className: "班级",
    classNamePlaceholder: "请选择班级",
    courseName: "课程名称",
    classAdviser: "班主任",
    department: "院系",
    courseType: "课程类别",
    courseCredit: "课程学分",
    courseTeacher: "任课教师",
    none: "无",

    studentNumber: "学生学号",
    studentName: "学生姓名",
    MethodOfAchievingGrades: "取得方式",
    usualGrade: "平时成绩",
    finaGrade: "期末成绩",
    skillScore: "技能成绩",
    totalMark: "总评成绩",
    resit: "补考",
    initialRepair: "初修",
    exemption: "免修",

    rebuild: "重修",
    pass: "及格",
    medium: '中等',
    good: '良好',
    qualified: "合格",
    excellent: "优秀",

    flunk: "不及格",
    belowStandard: "不合格",


    index: "索引",
    operate: "操作",

    assistanceSuggestions: "帮扶建议",
    time: "时间",
    analysis: "分析",
    earlyWarningRules: "预警规则",
    colorSign: "颜色标志",
    bjrs: "班级人数",
    cxqbkctgrs: "初修全部课程通过人数",
    bkhqbkctgrs: "全部课程通过人数",
    kcbtgrs: "课程不通过人数",

    yjkcfbqk: "预警课程分布情况",
    yjkcms: "预警课程门数",
  },
  SearchInfo: {
    term: "学期",
    termPlaceholder: "请选择学期",
    number: "学号",
    numberPlaceholder: "请输入学号",
    name: "姓名",
    namePlaceholder: "请输入姓名",
    namePlaceholder2: "请输入教师/班主任姓名",
    namePlaceholder3: "请输入教学管理员姓名",
    namePlaceholder4: "请输入系统管理员姓名",


    jobNumber: "工号",
    jobNumberPlaceholder: "请输入工号",
    position: "职位",
    positionPlaceholder: "请选择职位",
    department: "部门",
    departmentPlaceholder: "请选择部门",
    sex: "性别",
    sexPlaceholder: "请选择性别",
    man: "男",
    women: "女",
    earlyWarningLevel: "预警级别",
    earlyWarningLevelPlaceholder: "请选择预警级别",
    blueAlert: "蓝色预警",
    yellowAlert: "黄色预警",
    orangeAlert: "橙色预警",
    redAlert: "红色预警",
    detail: "详情",
    blueAlertNumber: "蓝色预警人数",
    yellowAlertNumber: "黄色预警人数",
    orangeAlertNumber: "橙色预警人数",
    redAlertNumber: "红色预警人数",
  },
  BtnText: {
    cancel: "取消",
    confirm: "确认",
    query: "查询",
    reset: "重置",
    create: "新增",
    delete: "删除",
    update: "修改",
    submit: "提交",
    save: "保存",
  },
  Tips: {
    pleaseSelectDeletedTeacher: "请先选择需要删除的教师",
    deletedTeacherTips: "此操作将删除该教师, 是否继续?",
    pleaseSelectDeletedUser: "请先选择需要删除的用户",
    deletedUserTips: "此操作将删除该用户, 是否继续?",
    pleaseSelectDeletedStu: "请先选择需要删除的学生",
    deletedStuTips: "此操作将删除该学生, 是否继续?",
    pleaseSelectDeletedTeachingAdministrator: "请先选择需要删除的教学管理员",
    deletedTeachingAdministratorTips: "此操作将删除该教学管理员, 是否继续?",
    qtxbfjy: "请填写帮扶建议",
  },
  EchartInfo: {
    ksqk: "考试情况",
    btgkcqk: "不通过课程情况",
    door: "门",
    bkqk: "补考情况",
    bktgkes: "补考通过课程数",
    bkwtgkcs: "补考未通过课程数",
    cxqk: "初修情况",
    cxtgkcs: "初修通过课程数",
    cxwtgkcs: "初修未通过课程数",
    courseCount: "课程数",
    gradingMethod: "考试类别",
    courseType: "课程类别",
  },
  DiaInfo: {
    warningDetails: "预警详情",
    stuFailedCoursesInfo: "该学生（%name）共有%number门课程不合格",
    earlyRule1: "不合格课程（低于60分）累计达$num门",
    earlyRule2: "不合格课程（低于60分）累计达$num-$num门",
    earlyRule3: "不合格课程（低于60分）累计达$num门及以上",
    dijixueqi: "%year年第%num学期",
    dijixueqi2: "一",
    dijixueqi3: "二",
    yjrsqk: "预警人数情况",
    peopleInTotal: "{b} 共 {c} ({d}%) 人",
    loginAgain: '用户登录已失效， 请重新登录。',

  },
};



// WEBPACK FOOTER //
// ./src/lang/zh.js